import { defineStore } from 'pinia'
import storage from '@/composables/useStorage'
import { setCookie, removeCookie } from '@/composables/useCookies'
// import { encrypt, decrypt } from '@/utils/crypto' // ❌ لسه مش محتاجه
import { showAlert } from '@/composables/useAlert'
// import { ref } from 'vue'
import { httpRequest } from '@/services/api'
import router from '@/router'

const currentUser = JSON.parse(storage.get('user'))

export const useAuthStore = defineStore('auth', {
  state: () => ({
    isLoggedIn: !!currentUser,
    isLoading: false,
    user: currentUser ?? {},
    permissions: [],
    role: currentUser?.type ?? 'guest',
    // step: ref(parseInt(storage.get('step')) || 1),
    // email: ref(storage.get('email') || ''),
    // otp: ref(parseInt(storage.get('otp')) || '')
  }),
  getters: {},
  actions: {
    // updateStep(newStep) {
    //   this.step = newStep;
    //   storage.set('step', newStep);
    // },

    async signIn(form) {
      this.isLoading = true;
      try {
        const formData = new FormData();
        formData.append("phone", form.phone);
        formData.append("country_code", form.country_code);
        formData.append("password", form.password);

        const response = await httpRequest("/user/login", {
          method: "POST",
          data: formData,
          isFile: true 
        });

        // Check if response contains token and user data
        if (!response?.data?.token || !response?.data?.user) {
          showAlert(response?.message || "بيانات الدخول غير صحيحة", "error");
          return false;
        }

        const { user, token } = response.data;
        this.isLoggedIn = true;
        setCookie("token", token);
        storage.set("user", JSON.stringify(user));
        this.user = user;
        this.role = user.type;

        showAlert("تم تسجيل الدخول بنجاح", "success");
        return true;
      } catch (error) {
        const errMsg =
          error.response?.data?.message ||
          "حدث خطأ أثناء تسجيل الدخول. حاول مرة أخرى.";
        showAlert(errMsg, "error");
        return false;
      } finally {
        this.isLoading = false;
      }
    },

    async register(form) {
      this.isLoading = true;
      try {
        const response = await httpRequest('/user/register', {
          method: 'POST',
          data: form
        });
        // console.log(response.data);
        const { token, user } = response.data;
        setCookie('token', token);
        storage.set('user', JSON.stringify(user));
        this.user = user;
        this.isLoggedIn = true;
        this.role = user.type || 'guest';
        showAlert("تم تسجيل الدخول بنجاح", 'success');
        return true; 
      } catch (error) {
        console.error(error);
        showAlert(error.response?.data?.message || error.message, 'error');
        return false; 
      } finally {
        this.isLoading = false;
      }
    },
async completeProfile(form) {
  this.isLoading = true;
  try {
    const formData = new FormData();
    formData.append("name", form.name);
    formData.append("email", form.email || "");
    formData.append("password", form.password);
    formData.append("type", form.type); 

    const response = await httpRequest("/user/complete-profile", {
      method: "POST",
      data: formData,
      isFile: true
    });

    if (response?.data?.user) {
      this.user = response.data.user;
      storage.set("user", JSON.stringify(this.user));
      showAlert("تم إكمال الملف الشخصي بنجاح", "success");
      return true;
    } else {
      showAlert("تعذر حفظ البيانات، حاول مرة أخرى", "error");
      return false;
    }
  } catch (error) {
    showAlert(error.response?.data?.message || error.message, "error");
    return false;
  } finally {
    this.isLoading = false;
  }
},

    async getUser() {
      this.isLoading = true
      return new Promise(async (resolve, reject) => {
        try {
          const response = await httpRequest('/me', { method: 'GET' })
          const { user } = response.data
          this.isLoggedIn = true
          this.user = user
          resolve()
        } catch (error) {
          if (error.response?.data)
            showAlert(error.response?.data?.message, 'error')
          else showAlert(error.message, 'error')
          reject(error)
        } finally {
          this.isLoading = false
        }
      })
    },

    async updateUser(data) {
      this.isLoading = true
      return new Promise(async (resolve, reject) => {
        try {
          const response = await httpRequest('/update-profile', { method: 'POST', data })
          const { user } = response.data
          this.user = user
          storage.set('user', JSON.stringify(user))
          showAlert(response.message, 'success')
          resolve()
        } catch (error) {
          if (error.response?.data)
            showAlert(error.response?.data?.message, 'error')
          else showAlert(error.message, 'error')
          reject(error)
        } finally {
          this.isLoading = false
        }
      })
    },

    // ❌ مؤجل: التحقق من الصلاحيات
    // async hasPermission(permission) {
    //   const encryptedPermissions = localStorage.getItem('permissions')
    //   const decryptedPermissions = JSON.parse(encryptedPermissions)
    //   const userPermissions = decrypt(decryptedPermissions)
    //   return userPermissions.includes(permission)
    // },

    flush() {
      storage.remove('user', 'permissions')
      removeCookie('token')
      this.user = {}
      this.isLoggedIn = false
      // this.updateStep(1)
      // router.push('/login')
    },

    async logOut() {
      this.isLoading = true
       this.flush()
      // return new Promise(async (resolve, reject) => {
      //   try {
      //     await httpRequest('/logout', { method: 'POST' }).then(() => {
      //       this.flush()
      //       resolve()
      //     })
      //   } catch (error) {
      //     console.error(error)
      //     reject(error)
      //   } finally {
      //     this.isLoading = false
      //   }
      // })
    },

    // ❌ مؤجل: استعادة كلمة المرور
    // async forgetPassword(form) {
    //   try {
    //     this.updateStep(2)
    //     storage.set('email', form.email)
    //     this.email = ref(form.email)
    //   } catch (error) {
    //     console.error(error)
    //     showAlert(error.response?.data?.message || 'Failed to send token.', 'error')
    //     throw error
    //   }
    // },

    // async verifyToken(form) {
    //   try {
    //     const requestData = {
    //       ...form,
    //       email: storage.get('email')
    //     }
    //     this.updateStep(3)
    //     storage.set('otp', form.otp)
    //   } catch (error) {
    //     console.error(error)
    //     showAlert(error.response?.data?.message || 'Failed to verify.', 'error')
    //     throw error
    //   }
    // },

    // async resetPassword(form) {
    //   try {
    //     const requestData = {
    //       ...form,
    //       email: storage.get('email'),
    //       otp: storage.get('otp')
    //     }
    //     const response = await httpRequest('/reset', { method: 'POST', data: requestData })
    //     this.updateStep(1)
    //     showAlert(response?.message || 'Password changed successfully', 'success')
    //     await router.push('/')
    //   } catch (error) {
    //     console.error(error)
    //     showAlert(error.response?.data?.message || 'Failed to reset password.', 'error')
    //     throw error
    //   }
    // }
  }
})
